module.exports = __webpack_public_path__ + "static/media/boss_gym.0961b645.png";